import { styled } from "@mui/material";
import { DataGridPro, DataGridProProps } from "@mui/x-data-grid-pro";
import React from "react";

export const DataGrid7 = styled(DataGridPro)(({ theme }) => ({
  border: 0,
  WebkitFontSmoothing: "auto",
  letterSpacing: "normal",
  "&.MuiDataGrid-root": {
    fontSize: "14px",
    border: "none",
  },
  "& .MuiDataGrid-main": {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "& .MuiDataGrid-columnsContainer": {
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiDataGrid-iconSeparator": {},
  "& .MuiDataGrid-columnHeaders": {
    borderTop: "none",
    borderRight: "none",
    borderLeft: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "& .MuiDataGrid-columnHeaderTitle": {
    fontSize: "13px",
    fontWeight: "600",
  },
  "&  .MuiDataGrid-columnHeaderTitleContainer": {
    alignItems: "flex-end",
    marginBottom: "10px",
  },
  "&  .MuiDataGrid-columnHeaderTitleContainerContent": {
    fontWeight: "600",
    overflow: "visible",
    lineHeight: "1.43rem",
    whiteSpace: "normal",
    textAlign: "bottom",
  },
  "& .MuiDataGrid-columnsContainer, .MuiDataGrid-cell": {
    borderLeft: "none",
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  "& .MuiDataGrid-virtualScroller": {
    borderTop: "none",
    borderRight: "1px solid lightgrey",
    borderLeft: "1px solid lightgrey",
    overflowX: "auto",
  },
  "& .MuiTablePagination-select": {
    ":focus-visible": {
      outlineColor: theme.palette.primary.main,
      outlineStyle: "solid",
      outlineWidth: "2px",
    },
  },
  "& .MuiDataGrid-pinnedColumns": {
    boxShadow: "none",
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiDataGrid-container--top [role=row]": {
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiDataGrid-columnHeader--pinnedLeft": {
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiDataGrid-columnHeader--pinnedRight": {
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiDataGrid-cell--pinnedLeft": {
    backgroundColor: theme.palette.background.paper,
  },
  "& .MuiDataGrid-pinnedColumnHeaders": {
    boxShadow: "none",
  },

  "& .MuiDataGrid-pinnedRows .MuiDataGrid-row": {
    boxShadow: "none",
    fontWeight: "600",
    backgroundColor: theme.palette.background.paper,
    borderTop: `3px solid ${theme.palette.divider}`,
  },
  "& .MuiDataGrid-detailPanel": {
    borderBottom: `1px solid ${theme.palette.divider}`,
    borderTop: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
  },
})) as React.ComponentType<DataGridProProps>;
